module.exports = __webpack_public_path__ + "4c9b47770f4ede8a6702bc61a7442689.jpg";